
<form class="p-0" #importFileForm="ngForm">

    <div class="progress" *ngIf="cumulativePercentComplete>0&&cumulativePercentComplete<100">
        <div *ngIf="cumulativePercentComplete<100" class="progress-bar progress-bar-striped bg-success" role="progressbar" [style.width.%]="cumulativePercentComplete">
        </div>
    </div>

    <div class="pb-2 busy-overlay-parent" [ngClass]="importInProgressCnt?'disabled':''">

        <div *ngIf="importInProgressCnt" class="font-weight-bold busy-overlay">
            <i class="fa fa-spinner fa-spin"></i>&nbsp;Processing...
        </div>

        <span class="m-1">
            <select name="importFormSelect" [(ngModel)]="selectedImportType" #importFormSelect
                    [ngClass]="{'empty-option':!selectedImportType}">
                <option [ngValue]="undefined" class="empty-option" selected disabled>-- Import Type --</option>
                <option *ngFor="let importType of importTypes" [ngValue]="importType">{{importType?.name}}</option>
            </select>
        </span>

        <span class="m-1 ml-0" *ngIf="selectedImportType && (selectedImportType.requiresStage || selectedImportType.acceptsStage)">
            <select name="stageSelect" [(ngModel)]="selectedStage" #stageSelect [required]="selectedImportType.requiresStage"
                    [ngClass]="{'empty-option':!selectedStage}">
                <option [ngValue]="undefined" class="empty-option" selected disabled>-- Stage --</option>
                <option *ngIf="selectedImportType.acceptsStage" [ngValue]="null">-- No Stage --</option>
                <option *ngFor="let stage of stageQueryRequest | async" [ngValue]="stage">{{stage.name}}</option>
            </select>
        </span>

        <span class="m-1 ml-0" *ngIf="selectedImportType == postProcessingService.baroCallLogImport">
            <select name="buildingSelect" [(ngModel)]="selectedBuilding" #buildingSelect required
                    [ngClass]="{'empty-option':!selectedBuilding}">
                <option [ngValue]="undefined" class="empty-option" selected disabled>-- Building --</option>
                <option *ngFor="let bldg of buildingQueryRequest | async" [ngValue]="bldg">{{bldg.id}} - {{bldg.commonName}}</option>
            </select>
        </span>

        <span class="m-1 ml-0" *ngIf="selectedImportType == postProcessingService.gpsLogImport">
            <select name="routeSelect" [(ngModel)]="selectedRoute" #routeSelect required
                    [ngClass]="{'empty-option':!selectedRoute}">
                <option [ngValue]="undefined" class="empty-option" selected disabled>-- Route --</option>
                 <option *ngFor="let route of routesQueryRequest | async" [ngValue]="route">{{route.id}} - {{route.id}}</option>
            </select>
        </span>


        <input name="fileInput"  #fileInput type="file" multiple
            class="ml-1"
            [disabled]="!selectedImportType||(!selectedStage && selectedImportType.requiresStage)"
            [attr.accept]="selectedImportType?.fileExtensions?.join(',')||'.csv,.xlsx,.xls,.txt'" (change)="onFileInputChanged($event)">
        <br/>
        
        <div class="d-flex align-items-center">
            <div class="d-flex">
                <button *ngIf="importNotStartedCnt>0 && importInProgressCnt == 0 && !!importFileTrackers?.length"
                    class="btn btn-primary m-1" (click)="onImportFiles()">
                    <i class="fa fa-upload"></i> Import {{importNotStartedCnt>1?'All':''}}
                </button>
                <button *ngIf="importFileTrackers.length" class="btn btn-warning m-1" (click)="reset()">
                    Reset
                </button>
            </div>
            <div *ngIf="selectedImportType" class="d-flex align-items-center">
                <label *ngIf="selectedImportType.supportsRejections" class="m-2 text-secondary" for="abort-on-rejections">
                    <input type="checkbox" name="abort-on-rejections" id="abort-on-rejections" [(ngModel)]="bAbortOnRejectedRows"
                    [disabled]="importInProgressCnt>0" />
                    Abort on rejected rows (insert errors, duplicates, etc...)
                </label>
                <label *ngIf="selectedImportType == postProcessingService.baroCallLogImport"
                        class="m-2 text-secondary" for="baro-utc-to-building-local-time">
                    <input type="checkbox" name="baro-utc-to-building-local-time" id="baro-utc-to-building-local-time"
                        [(ngModel)]="bBaroUtcToBuildingLocalTime"
                        [disabled]="importInProgressCnt>0" />
                    Convert UTC timestamps to building local time
                </label>
            </div>
        </div>
    </div>

    <div class="card my-1" *ngFor="let import of importFileTrackers;">
    <div [attr.role]="import.inProgress||import.attempted?'button':''" class="card-header p-2 d-flex align-items-center w-100"
        (click)="import.uiExpanded=!import.uiExpanded">
        <div class="d-flex justify-content-between w-100 align-items-center">
            <div class="d-flex align-items-center">
                <i *ngIf="import.inProgress||import.attempted" class="fa ml-1 mr-3" [ngClass]="import.uiExpanded?'fa-chevron-down':'fa-chevron-right'"></i>
                <button *ngIf="importFileTrackers.length>1"
                    class="btn btn-primary mr-3" (click)="$event.stopPropagation();importFile(import)"
                    [disabled]="import.inProgress||import.result"
                    [attr.title]="'Import ' + import.file.name">
                    <i class="fa fa-upload"></i>
                </button>
                <div>
                    <span class="font-weight-bold mr-2">{{import.file.name}}</span>
                    <span class="text-secondary">{{import.file.size|bytes}}</span>
                </div>
            </div>
            <div class="d-flex align-items-center px-2">
                <i *ngIf="import.inProgress" class="fa fa-spinner fa-spin mx-2"></i>
                <ng-container *ngIf="!import.inProgress&&import.attempted">
                    <i *ngIf="import.successMsg||!import.errorMsg" class="fa fa-check-circle text-success"></i>
                    <i *ngIf="import.errorMsg" class="fa fa-exclamation-triangle text-warning"></i>
                </ng-container>
            </div>
        </div>
    </div>
    <div class="card-body p-2" *ngIf="import.uiExpanded&&(import.inProgress||import.attempted)">
    <div *ngIf="import.errorMsg||import.result?.rejections?.length" class="alert alert-danger d-flex flex-row justify-content-between m-0">
        <div class="d-flex flex-column align-items-start">
            <div>{{import.errorMsg}}</div>
            <div class="d-flex flex-row card p-1 mt-1 align-items-center flex-shrink-1"
                *ngIf="import.result?.rejections?.length">
                Rejected
                <button class="btn btn-secondary small-button"
                    title="JSON with all details about rejected rows including specific errors"
                    [disabled]="bDownloading" (click)="downloadRejectedJson(import)">
                    <i class="fa fa-download"></i>
                </button>
                <button class="btn btn-secondary small-button" title="Tabular form (without error messages)"
                [disabled]="bDownloading" (click)="downloadRejectedRows(import)">
                    <i class="fa fa-table"></i>
                </button>
            </div>
        </div>
        <!-- Assuming we dont need to clear out error since each import can be collapsed for similar effect
        <div class="">
            <i class="fa fa-times" role="button" (click)="import.errorMsg=null"></i>
        </div>
        -->
    </div>
    <div *ngIf="import.inProgress&&import.percentComplete==100" class="alert alert-info m-0">
        Uploaded (importing...)
    </div>
    <div *ngIf="import.successMsg" class="alert alert-success d-flex flex-row justify-content-between m-0">
        {{import.successMsg}}
        <!--
        <div class="pl-3">
            <i class="fa fa-times" role="button" (click)="import.successMsg=null"></i>
        </div>
        -->
    </div>

    <ng-container *ngIf="import.importType == postProcessingService.oneSourceMasterTrackerImport">
    <ng-container *ngLet="asOneSourceResult(import.result)?.buildingResults as bldgResults">
    <div *ngIf="bldgResults" [ngClass]="bldgResults.errorMsg?'alert alert-danger col':'alert alert-success col'" style="position: relative;">
        <div role="button" (click)="bldgResults.uiExpanded=!bldgResults.uiExpanded">
            <span class="h5">Buildings</span>&nbsp;
            <i class="fa" [ngClass]="bldgResults.uiExpanded?'fa-chevron-down':'fa-chevron-right'"></i>
        </div>
        <div *ngIf="bldgResults.uiExpanded" class="d-flex flex-row justify-content-between">
            <div *ngIf="bldgResults.created?.length > 0" class="col">
                Created Buildings:
                <ul>
                    <li *ngFor="let createdBuilding of bldgResults.created">
                        {{createdBuilding.id}}
                    </li>
                </ul>
            </div>

            <div *ngIf="bldgResults.updated?.length > 0" class="col">
                Updated Buildings:
                <ul>
                    <li *ngFor="let updatedBuilding of bldgResults.updated">
                        {{updatedBuilding.id}}
                    </li>
                </ul>
            </div>

            <div *ngIf="bldgResults.deleted?.length > 0" class="col">
                Deleted Buildings:
                <ul>
                    <li *ngFor="let deletedBuilding of bldgResults.deleted">
                        {{deletedBuilding.id}}
                    </li>
                </ul>
            </div>

            <div *ngIf="bldgResults.errorMsg" class="col">
                Building Error:
                <ul>
                    {{bldgResults.errorMsg}}
                </ul>
            </div>

        </div>
        <div class="pl-3" style="position: absolute; top: 8px; right: 16px;">
            <i class="fa fa-times" role="button" (click)="asOneSourceResult(import.result).buildingResults=undefined"></i>
        </div>
    </div>
    </ng-container>

    <ng-container *ngLet="asOneSourceResult(import.result)?.pointResults as pointResults">
    <div *ngIf="pointResults" [ngClass]="pointResults?.errorMsg?'alert alert-danger col':'alert alert-success col'" style="position: relative;">
        <div role="button" (click)="pointResults.uiExpanded=!pointResults.uiExpanded">
            <span class="h5">Points</span>&nbsp;
            <i class="fa" [ngClass]="pointResults.uiExpanded?'fa-chevron-down':'fa-chevron-right'"></i>
        </div>
        <div *ngIf="pointResults.uiExpanded" class="d-flex flex-row justify-content-between">
            <div *ngIf="pointResults.created?.length > 0" class="col">
                Created Points:
                <ul>
                    <li *ngFor="let createdPoint of pointResults.created">
                        {{createdPoint._id}}
                    </li>
                </ul>
            </div>

            <div *ngIf="pointResults.updated?.length > 0" class="col">
                Updated Points:
                <ul>
                    <li *ngFor="let updatedPoint of pointResults.updated">
                        {{updatedPoint._id}}
                    </li>
                </ul>
            </div>

            <div *ngIf="pointResults.deleted?.length > 0" class="col">
                Deleted Points:
                <ul>
                    <li *ngFor="let deletedPoint of pointResults.deleted">
                        {{deletedPoint._id}}
                    </li>
                </ul>
            </div>

            <div *ngIf="pointResults.errorMsg" class="col">
                Point Error:
                <ul>
                    {{pointResults.errorMsg}}
                </ul>
            </div>

        </div>
        <div class="pl-3" style="position: absolute; top: 8px; right: 16px;">
            <i class="fa fa-times" role="button" (click)="asOneSourceResult(import.result).pointResults=undefined"></i>
        </div>
    </div>
    </ng-container>

    <ng-container *ngLet="asOneSourceResult(import.result)?.pathResults as pathResults">
    <div *ngIf="pathResults" [ngClass]="pathResults.errorMsg?'alert alert-danger col':'alert alert-success col'" style="position: relative;">
        <div role="button" (click)="pathResults.uiExpanded=!pathResults.uiExpanded">
            <span class="h5">Paths</span>&nbsp;
            <i class="fa" [ngClass]="pathResults.uiExpanded?'fa-chevron-down':'fa-chevron-right'"></i>
        </div>
        <div *ngIf="pathResults.uiExpanded" class="d-flex flex-row justify-content-between">
            <div *ngIf="pathResults.created?.length > 0" class="col">
                Created Paths:
                <ul>
                    <li *ngFor="let createdPath of pathResults.created">
                        {{createdPath.id}}
                    </li>
                </ul>
            </div>

            <div *ngIf="pathResults.updated?.length > 0" class="col">
                Updated Paths:
                <ul>
                    <li *ngFor="let updatedPath of pathResults.updated">
                        {{updatedPath.id}}
                    </li>
                </ul>
            </div>

            <div *ngIf="pathResults.deleted?.length > 0" class="col">
                Deleted Paths:
                <ul>
                    <li *ngFor="let deletedPath of pathResults.deleted">
                        {{deletedPath.id}}
                    </li>
                </ul>
            </div>

            <div *ngIf="pathResults.errorMsg" class="col">
                Path Error:
                <ul>
                    {{pathResults.errorMsg}}
                </ul>
            </div>

        </div>
        <div class="pl-3" style="position: absolute; top: 8px; right: 16px;">
            <i class="fa fa-times" role="button" (click)="asOneSourceResult(import.result).pathResults=undefined"></i>
        </div>
    </div>
    </ng-container>

    <ng-container *ngLet="asOneSourceResult(import.result)?.waypointResults as waypointResults">
    <div *ngIf="waypointResults" [ngClass]="waypointResults.errorMsg?'alert alert-danger col':'alert alert-success col'" style="position: relative;">
        <div role="button" (click)="waypointResults.uiExpanded=!waypointResults.uiExpanded">
            <span class="h5">Waypoints</span>&nbsp;
            <i class="fa" [ngClass]="waypointResults.uiExpanded?'fa-chevron-down':'fa-chevron-right'"></i>
        </div>
        <div *ngIf="waypointResults.uiExpanded" class="d-flex flex-row justify-content-between">
            <div *ngIf="waypointResults.created?.length > 0" class="col">
                Created Waypoints:
                <ul>
                    <li *ngFor="let createdWaypoint of waypointResults.created">
                        {{createdWaypoint.pathId}}|{{createdWaypoint.pointId}}
                    </li>
                </ul>
            </div>

            <div *ngIf="waypointResults.updated?.length > 0" class="col">
                Updated Waypoints:
                <ul>
                    <li *ngFor="let updatedWaypoint of waypointResults.updated">
                        {{updatedWaypoint.pathId}}|{{updatedWaypoint.pointId}}
                    </li>
                </ul>
            </div>

            <div *ngIf="waypointResults.deleted?.length > 0" class="col">
                Deleted Waypoints:
                <ul>
                    <li *ngFor="let deletedWaypoint of waypointResults.deleted">
                        {{deletedWaypoint.pathId}}|{{deletedWaypoint.pointId}}
                    </li>
                </ul>
            </div>

            <div *ngIf="waypointResults.errorMsg" class="col">
                Waypoints Error:
                <ul>
                    {{waypointResults.errorMsg}}
                </ul>
            </div>

        </div>
        <div class="pl-3" style="position: absolute; top: 8px; right: 16px;">
            <i class="fa fa-times" role="button" (click)="asOneSourceResult(import.result).waypointResults=undefined"></i>
        </div>
    </div>
    </ng-container>

    <ng-container *ngLet="asOneSourceResult(import.result)?.routeResults as routeResults">
    <div *ngIf="routeResults" [ngClass]="routeResults.errorMsg?'alert alert-danger col':'alert alert-success col'" style="position: relative;">
        <div role="button" (click)="routeResults.uiExpanded=!routeResults.uiExpanded">
            <span class="h5">Routes</span>&nbsp;
            <i class="fa" [ngClass]="routeResults.uiExpanded?'fa-chevron-down':'fa-chevron-right'"></i>
        </div>
        <div *ngIf="routeResults.uiExpanded" class="d-flex flex-row justify-content-between">
            <div *ngIf="routeResults.created?.length > 0" class="col">
                Created Routes:
                <ul>
                    <li *ngFor="let createdRoute of routeResults.created">
                        {{createdRoute.id}}
                    </li>
                </ul>
            </div>

            <div *ngIf="routeResults.updated?.length > 0" class="col">
                Updated Routes:
                <ul>
                    <li *ngFor="let updatedRoute of routeResults.updated">
                        {{updatedRoute.id}}
                    </li>
                </ul>
            </div>

            <div *ngIf="routeResults.deleted?.length > 0" class="col">
                Deleted Routes:
                <ul>
                    <li *ngFor="let deletedRoute of routeResults.deleted">
                        {{deletedRoute.id}}
                    </li>
                </ul>
            </div>

            <div *ngIf="routeResults.errorMsg" class="col">
                Routes Error:
                <ul>
                    {{routeResults.errorMsg}}
                </ul>
            </div>

        </div>
        <div class="pl-3" style="position: absolute; top: 8px; right: 16px;">
            <i class="fa fa-times" role="button" (click)="asOneSourceResult(import.result).routeResults=undefined"></i>
        </div>
    </div>
    </ng-container>
    </ng-container><!-- End of onesource import results container-->


    <ng-container *ngIf="import.importType == postProcessingService.volunteersImport">
    <ng-container *ngLet="asVolunteerResult(import.result)?.volunteerResults as volunteerResults">
    <div *ngIf="volunteerResults" [ngClass]="volunteerResults.errorMsg?'alert alert-danger col':'alert alert-success col'" style="position: relative;">
        <div role="button" (click)="volunteerResults.uiExpanded=!volunteerResults.uiExpanded">
            <span class="h5">Volunteers</span>&nbsp;
            <i class="fa" [ngClass]="volunteerResults.uiExpanded?'fa-chevron-down':'fa-chevron-right'"></i>
        </div>
        <div *ngIf="volunteerResults.uiExpanded" class="d-flex flex-row justify-content-between">
            <div *ngIf="volunteerResults.created?.length > 0" class="col">
                Created Volunteers:
                <ul>
                    <li *ngFor="let createdVolunteer of volunteerResults.created">
                        {{createdVolunteer.email}}
                    </li>
                </ul>
            </div>

            <div *ngIf="volunteerResults.updated?.length > 0" class="col">
                Updated Volunteers:
                <ul>
                    <li *ngFor="let updatedVolunteer of volunteerResults.updated">
                        {{updatedVolunteer.email}}
                    </li>
                </ul>
            </div>

            <div *ngIf="volunteerResults.deleted?.length > 0" class="col">
                Volunteer already Exists:
                <ul>
                    <li *ngFor="let deletedVolunteer of volunteerResults.deleted">
                        {{deletedVolunteer}}
                    </li>
                </ul>
            </div>

            <div *ngIf="volunteerResults.errorMsg" class="col">
                Volunteer Error:
                <ul>
                    {{volunteerResults.errorMsg}}
                </ul>
            </div>

        </div>
        <div class="pl-3" style="position: absolute; top: 8px; right: 16px;">
            <i class="fa fa-times" role="button" (click)="asVolunteerResult(import.result).volunteerResults=undefined"></i>
        </div>
    </div>
    </ng-container>
    <ng-container *ngLet="asVolunteerResult(import.result)?.handsetResults as handsetResults">
    <div *ngIf="handsetResults" [ngClass]="handsetResults.errorMsg?'alert alert-danger col':'alert alert-success col'" style="position: relative;">
        <div role="button" (click)="handsetResults.uiExpanded=!handsetResults.uiExpanded">
            <span class="h5">Handsets</span>&nbsp;
            <i class="fa" [ngClass]="handsetResults.uiExpanded?'fa-chevron-down':'fa-chevron-right'"></i>
        </div>
        <div *ngIf="handsetResults.uiExpanded" class="d-flex flex-row justify-content-between">
            <div *ngIf="handsetResults.created?.length > 0" class="col">
                Created Handsets:
                <ul>
                    <li *ngFor="let createdHandset of handsetResults.created">
                        {{createdHandset}}
                    </li>
                </ul>
            </div>

            <div *ngIf="handsetResults.updated?.length > 0" class="col">
                Updated Handsets:
                <ul>
                    <li *ngFor="let updatedHandset of handsetResults.updated">
                        {{updatedHandset}}
                    </li>
                </ul>
            </div>

            <div *ngIf="handsetResults.deleted?.length > 0" class="col">
                Volunteer Not Found:
                <ul>
                    <li *ngFor="let deletedHandset of handsetResults.deleted">
                        {{deletedHandset}}
                    </li>
                </ul>
            </div>

            <div *ngIf="handsetResults.errorMsg" class="col">
                Handset Error:
                <ul>
                    {{handsetResults.errorMsg}}
                </ul>
            </div>

        </div>
        <div class="pl-3" style="position: absolute; top: 8px; right: 16px;">
            <i class="fa fa-times" role="button" (click)="asVolunteerResult(import.result).handsetResults=undefined"></i>
        </div>
    </div>
    </ng-container>
    </ng-container><!-- End of volunteers import results container-->

    </div>
    </div>
</form>